// antd
import { Modal, Typography } from 'antd'

// assets
import { BinIcon } from '../../assets/icons'

// components
import Button from '../button/button'

const DeletePopUp = ({
    previewDelete,
    onCancel,
    onDelete,
    modalTitle,
    loadingButton,
    keyModal,
    pageKey,
    profileModalState,
}) => {
    const { Text } = Typography

    const checkKeyModal = (key) => {
        switch (key) {
            case 'closeRole':
                return 'Are you sure you want to close the role?'

            case 'teamMember':
                return 'Are you sure you want to remove your Team Member?'

            case 'logout':
                return 'Are you sure you want to logout?'

            case 'revokedOffer':
                return 'Are you sure you want to Revoked this offer?'

            default:
                return `Are you sure you want to delete your ${
                    profileModalState?.delete ? 'Video' : pageKey
                }?`
        }
    }

    const getActionButtonText = () => {
        if (keyModal === 'revokedOffer') return 'Revoked'
        if (keyModal === 'closeRole') return 'Close'
        if (keyModal === 'logout') return 'Logout'
        if (keyModal === 'teamMember') return 'Remove'
        return 'Delete'
    }

    return (
        <Modal
            closable={false}
            open={previewDelete}
            destroyOnHidden={true}
            onCancel={onCancel}
            centered
            width={400}
            styles={{
                content: {
                    padding: '32px',
                    borderRadius: '12px',
                },
                body: {
                    padding: 0,
                },
            }}
            title={null}
            footer={null}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                }}
            >
                {/* Icon Container */}
                <div
                    style={{
                        width: '64px',
                        height: '64px',
                        borderRadius: '50%',
                        backgroundColor: '#fef2f2',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '20px',
                    }}
                >
                    <div
                        style={{
                            width: '32px',
                            height: '32px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <BinIcon />
                    </div>
                </div>

                {/* Title */}
                <Text
                    style={{
                        fontSize: '20px',
                        fontWeight: 600,
                        color: '#1e293b',
                        marginBottom: '12px',
                        display: 'block',
                        textTransform: 'capitalize',
                    }}
                >
                    {modalTitle}
                </Text>

                {/* Description */}
                <Text
                    style={{
                        fontSize: '14px',
                        color: '#64748b',
                        lineHeight: '20px',
                        marginBottom: '32px',
                        display: 'block',
                        maxWidth: '320px',
                    }}
                >
                    {checkKeyModal(keyModal)}
                </Text>

                {/* Action Buttons */}
                <div
                    style={{
                        display: 'flex',
                        gap: '12px',
                        width: '100%',
                        justifyContent: 'flex-end',
                        marginTop: '20px',
                    }}
                >
                    <Button
                        props={{
                            text: 'Cancel',
                            onClick: onCancel,
                            buttonType: 'default',
                            style: {
                                minWidth: '100px',
                                height: '40px',
                                borderRadius: '8px',
                                border: '1px solid #e2e8f0',
                                backgroundColor: '#ffffff',
                                color: '#475569',
                                fontWeight: 500,
                            },
                        }}
                    />
                    <Button
                        props={{
                            text: getActionButtonText(),
                            onClick: onDelete,
                            danger: true,
                            loadingButton,
                            style: {
                                minWidth: '100px',
                                height: '40px',
                                borderRadius: '8px',
                                backgroundColor: '#ef4444',
                                border: 'none',
                                fontWeight: 500,
                                color: '#ffffff',
                            },
                        }}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default DeletePopUp
